/**
 * Portal ICAVI - Serviço de domínio: Colaboradores
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const colaboradoresServiceMethods = {
    async getColaboradores() {
        try {
            const response = await api.get('/api/colaboradores/local/list');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar colaboradores:', error);
            throw error;
        }
    },
    async getCadastroColaboradores(params = {}) {
        try {
            const response = await api.get('/api/cadastro-colaboradores', {
                params,
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar colaboradores cadastrados:', error);
            throw error;
        }
    },
    async saveColaborador(colaborador) {
        try {
            const response = await api.post('/api/cadastro-colaboradores', colaborador);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao salvar colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async createColaborador(dados) {
        try {
            const response = await api.post('/api/cadastro-colaboradores', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao criar colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async updateColaborador(colaboradorId, dados) {
        try {
            const response = await api.put(`/api/cadastro-colaboradores/${colaboradorId}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async deleteColaborador(colaboradorId) {
        try {
            const response = await api.delete(`/api/cadastro-colaboradores/${colaboradorId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async getColaboradorHistorico(colaboradorId) {
        try {
            const response = await api.get(`/api/cadastro-colaboradores/${colaboradorId}/historico`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar histórico do colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async buscarCartaoAgillitasColaborador(dados) {
        try {
            const response = await api.post('/api/cadastro-colaboradores/agillitas/buscar-cartao', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar cartao Agillitas do colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async uploadCnhColaborador(colaboradorId, arquivo, cnh) {
        try {
            const formData = new FormData();
            formData.append('arquivo', arquivo);
            if (cnh) {
                formData.append('cnh', cnh);
            }
            const response = await api.post(`/api/colaboradores/${colaboradorId}/cnh/upload`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao enviar CNH do colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    async atualizarCnhColaborador(colaboradorId, cnh) {
        try {
            const response = await api.put(`/api/colaboradores/${colaboradorId}/cnh`, { cnh });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar CNH do colaborador:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
